import { gql, useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import defaultFarmFields from '../../constants/defaultFarmFields';
import FormContainer from '../FormContainer';
import FarmForm from './FarmForm';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';
import { CURRENT_YEAR } from '../../constants/years';

const CREATE_FARM_MUTATION = gql`
  mutation CreateFarm($input: CreateFarmInput!) {
    createFarm(input: $input) {
      result {
        id
        updatedAt
        ${defaultFarmFields.join(' ')}
      }
      errors
    }
  }
`;

const INITIAL_FORM_VALUES = {
  name: '',
  startYear: CURRENT_YEAR,
  tags: '',
  address: '',
  growingZone: '',
  mapCenter: { lat: undefined, lng: undefined },
};

const componentPropTypes = {
  // If teamId is provided, the form will be prefilled with the team id
  // and the team selector won't be shown.
  teamId: PropTypes.string,
};

const NewFarm = ({ teamId, refetchQuery, showBreadcrumbs = false }) => {
  const navigate = useNavigate();

  const initialValues = {
    ...INITIAL_FORM_VALUES,
    ...(teamId ? { team: { id: teamId } } : {}),
  };

  const [createFarmMutation] = useMutation(CREATE_FARM_MUTATION, {
    refetchQueries: [{ query: refetchQuery, variables: { id: teamId } }],
    onCompleted: ({ createFarm }) => {
      if (createFarm.result) {
        navigate('..');
      }
    },
  });

  useSetBreadcrumbEffect(showBreadcrumbs ? [{ display: 'New' }] : null, [
    showBreadcrumbs,
  ]);

  return (
    <FormContainer className="mt-3">
      <h2>Add a new project site</h2>
      <FarmForm
        saveFarmMutation={createFarmMutation}
        initialValues={initialValues}
        submitButtonText="Create Farm"
        successMessage="Farm created successfully"
        onCancel={() => navigate('..')}
        showTeamSelector={!teamId}
      />
    </FormContainer>
  );
};

NewFarm.propTypes = componentPropTypes;

export default NewFarm;
